var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.mIntroducers),function(introducer){return _c('el-tag',{key:introducer.introducingType.id,staticClass:"tag-item"},[_vm._v(_vm._s(introducer.introducingType.value))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }